export const placementTags = [
  'No feature',
  'Featured - category',
  'Featured - lead home page',
] as const;
